$('.trusted_slider').slick({
  dots:false,
  infinite:true,
  speed: 300,
  centerMode: true,
  autoplay:true,
  centerPadding: '60px',
  arrows:false,
  slidesToShow: 3,
  slidesToScroll:1,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
        infinite: true,
        dots:false
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ]
});



if (window.matchMedia("(max-width: 767px)").matches) {
    $('.ctm-grid').slick({
      infinite: false,
      slidesToShow:1,
      slidesToScroll:1
    });
}

document.addEventListener("click", function (e) {
  const label = e.target.closest(".ctm_label-Size");
  if (!label) return;

  const group = label.closest(".custom-Size");
  const wrapper = label.closest(".product-form__input--pill");

  if (!group || !wrapper) return;

  // active class remove (sirf size group me)
  group.querySelectorAll(".ctm_label-Size").forEach(el => {
    el.classList.remove("active");
  });

  label.classList.add("active");

  // input handle
  group.querySelectorAll('input[type="radio"]').forEach(input => {
    input.checked = false;
  });

  const input = wrapper.querySelector('input[type="radio"]');

  if (input) {
    input.checked = true;
    input.click(); // Shopify variant trigger
  }
});



document.addEventListener("click", function (e) {
  const label = e.target.closest(".ctm_label-Color");
  if (!label) return;

  const group = label.closest(".custom-Color");
  const wrapper = label.closest(".product-form__input--pill");

  if (!group || !wrapper) return;

  // active class remove (sirf color group me)
  group.querySelectorAll(".ctm_label-Color").forEach(el => {
    el.classList.remove("active");
  });

  label.classList.add("active");

  // input handle
  group.querySelectorAll('input[type="radio"]').forEach(input => {
    input.checked = false;
  });

  const input = wrapper.querySelector('input[type="radio"]');

  if (input) {
    input.checked = true;
    input.click(); // Shopify variant trigger
  }
});

document.addEventListener("DOMContentLoaded", function () {

  const colorGroup = document.querySelector('.custom-Color');
  if (!colorGroup) return;

  const checkedInput = colorGroup.querySelector('input[type="radio"]:checked');
  if (!checkedInput) return;

  const wrapper = checkedInput.closest('.product-form__input--pill');
  const label = wrapper?.querySelector('.ctm_label-Color');

  if (label) {
    colorGroup.querySelectorAll('.ctm_label-Color').forEach(el => {
      el.classList.remove('active');
    });

    label.classList.add('active');
  }

});